import { z } from "zod";
import type { DocumentTypeConfig } from "../types";

export { isAllowedCountryCode } from "../rules";

export const NationalIdCardDataSchema = z.object({
  first_name: z.string(),
  last_name: z.string(),
  birth_date: z.string(),
  birth_place_city: z.string(),
  birth_place_country_code: z.string().optional(),
  sex: z.enum(["male", "female", "neutral"]),
  nationality_country_code: z.string(),
  issue_date: z.string(),
  expiration_date: z.string(),
  document_number: z.string(),
});

export type NationalIdCardData = z.infer<typeof NationalIdCardDataSchema>;

export const NationalIdCardExtractionSchema = z.object({
  isValidDocumentType: z.boolean(),
  reason: z.string().optional(),
  hasRecto: z.boolean(),
  hasVerso: z.boolean(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  birth_date: z.string().nullable(),
  birth_place_city: z.string().nullable(),
  birth_place_country_code: z.string().nullable(),
  sex: z.enum(["male", "female", "neutral"]).nullable(),
  nationality_country_code: z.string().nullable(),
  issue_date: z.string().nullable(),
  expiration_date: z.string().nullable(),
  document_number: z.string().nullable(),
});

export type NationalIdCardExtraction = z.infer<typeof NationalIdCardExtractionSchema>;

export const NationalIdCardContextSchema = z.object({
  talentId: z.guid(),
});

export type NationalIdCardContext = z.infer<typeof NationalIdCardContextSchema>;

type NationalIdCardConfig = DocumentTypeConfig<typeof NationalIdCardDataSchema, typeof NationalIdCardContextSchema>;

export const NATIONAL_ID_CARD_CONFIG: NationalIdCardConfig = {
  documentType: "national_id_card",
  documentName: "Carte nationale d'identité",
  maxFiles: 2,
  acceptedMimeTypes: ["image/jpeg", "image/png", "application/pdf"],
  dataSchema: NationalIdCardDataSchema,
  contextSchema: NationalIdCardContextSchema,
  requiredFields: [
    "first_name",
    "last_name",
    "birth_date",
    "birth_place_city",
    "sex",
    "nationality_country_code",
    "expiration_date",
    "issue_date",
    "document_number",
  ],
  fieldLabels: {
    first_name: "Prénom",
    last_name: "Nom",
    birth_date: "Date de naissance",
    birth_place_city: "Ville de naissance",
    birth_place_country_code: "Pays de naissance",
    sex: "Sexe",
    nationality_country_code: "Nationalité",
    issue_date: "Date de délivrance",
    expiration_date: "Date d'expiration",
    document_number: "Numéro de document",
  },
};
